import { render, staticRenderFns } from "./CourseModal.vue?vue&type=template&id=75389782&scoped=true"
import script from "./CourseModal.vue?vue&type=script&lang=js"
export * from "./CourseModal.vue?vue&type=script&lang=js"
import style0 from "./CourseModal.vue?vue&type=style&index=0&id=75389782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75389782",
  null
  
)

export default component.exports